import { useEffect, useState } from "react";
import {
  AlarmItemWrapper,
  AlarmListWrapper,
  AlarmNotificationToggle,
  AlarmNotificationToggleWrapper,
  AlarmNotificationWrapper,
} from "../style";
import {
  getNoticesListAndRead,
  getNotificationSetting,
  NotificationResponse,
  NotificationType,
  updateNotificationSetting,
} from "../../../../api/user-notification";
import { useHistory } from "react-router-dom";

const AlarmList = () => {
  const [list, setList] = useState<NotificationResponse[]>([]);
  const [notificationSetting, setNotificationSetting] = useState<boolean>(true);
  const history = useHistory();
  const getDate = async () => {
    try {
      const res = await getNoticesListAndRead();
      setList(res.list);
      const setting = await getNotificationSetting();
      setNotificationSetting(setting.isPushEnabled);
    } catch {
      setList([]);
    }
  };

  const handleClick = async () => {
    try {
      const res = await updateNotificationSetting(!notificationSetting);
      setNotificationSetting(res.isPushEnabled);
    } catch {
      setNotificationSetting(notificationSetting);
    }
  };

  useEffect(() => {
    getDate();
  }, []);

  const formatTime = (time: number) => {
    if (time >= 86400) {
      const newTime = Math.floor(time / 86400);
      return `${newTime}일`;
    } else if (time >= 3600) {
      const newTime = Math.floor(time / 3600);
      return `${newTime}시간`;
    } else if (time >= 60) {
      const newTime = Math.floor(time / 60);
      return `${newTime}분`;
    } else {
      return "방금";
    }
  };

  const getTitle = (type: NotificationType) => {
    switch (type) {
      case NotificationType.WALLET:
        return "지갑";
      case NotificationType.TOURNAMENT:
        return "토너먼트";
      case NotificationType.SYSTEM:
        return "시스템";
      default:
        return "";
    }
  };

  return (
    <AlarmListWrapper>
      <AlarmNotificationWrapper>
        <div className="title">알림</div>
        <AlarmNotificationToggleWrapper
          isNotification={notificationSetting}
          onClick={handleClick}
        >
          <AlarmNotificationToggle isNotification={notificationSetting} />
        </AlarmNotificationToggleWrapper>
      </AlarmNotificationWrapper>
      {list.length === 0 ? (
        <div className="no-data">최근 알림이 없습니다.</div>
      ) : (
        list.map((item, index) => (
          <AlarmItemWrapper
            isRead={item.isRead}
            key={index}
            onClick={() => {
              if (item.goToPage) {
                history.push(item.goToPage);
              }
              if (item.type === NotificationType.WALLET) {
                history.push("/wallet");
              }
            }}
          >
            <div className="icon">
              <img
                src={`/image-web/alarm/${
                  item.type + (item.isRead ? "" : "-read")
                }.svg`}
                alt="icon"
              />
            </div>
            <div className="item-wrapper">
              <div className="top">
                <div className="title">{getTitle(item.type)} 알림</div>
                <div className="time">{formatTime(item.elapsedTime)}전</div>
              </div>
              <div className="text">{item.content}</div>
            </div>
          </AlarmItemWrapper>
        ))
      )}
    </AlarmListWrapper>
  );
};

export default AlarmList;
